<script>
	export let size = "24px";
	export let colour = "#e46937";
	export let fill = "none";
	export let strokeWidth = "2";
</script>

<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" {fill}>
	<path
		d="M12 21C16.9706 21 21 16.9706 21 12C21 7.0294 16.9706 2.99994 12 2.99994C7.0294 2.99994 2.99994 7.0294 2.99994 12C2.99994 16.9706 7.0294 21 12 21Z"
		stroke={colour}
		stroke-linecap="square"
		stroke-linejoin="round"
		stroke-width={strokeWidth}
	/><path
		d="M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
		fill={colour}
	/>
	<path d="M12 17V11" stroke={colour} stroke-width="2" />
</svg>
